import React from 'react';

/**
 * Esconde parte do nome, mostrando apenas
 * o último nome e a inicial do primeiro.
 * Exemplo: "João da Silva" → "Silva, J"
 */
export const esconderNome = (nome) => {
	const nomeTrim = (nome || '').trim();
	let nomeFormatado = '';
	if (nomeTrim.length > 1) {
		const partes = nomeTrim.split(' ').filter(Boolean);
		const primeiro = partes[0] || '';
		const ultimo = partes[partes.length - 1] || '';
		nomeFormatado = `${ultimo}, ${primeiro[0] || ''}`;
	}

	return nomeFormatado;
};

/**
 * Converte minutos em formato de tempo HH:MM:SS.
 * Aceita minutos inteiros ou decimais.
 * Exemplo: 90 → "01:30:00"
 * Exemplo: 5.5 → "00:05:30"
 */
export const formatarTempo = (minutos) => {
	const totalSegundos = minutos * 60;
	const horas = Math.floor(totalSegundos / 3600);
	const minutosRestantes = Math.floor((totalSegundos % 3600) / 60);
	const segundos = totalSegundos % 60;

	const hh = String(horas).padStart(2, '0');
	const mm = String(minutosRestantes).padStart(2, '0');
	const ss = String(segundos).padStart(2, '0');

	// return `${hh}:${mm}:${ss}`;
	return `${horas}h${mm}m`;

};

export const cardProtocolo = (protocolo) => {
	let labelProtcolo = '';
	if (protocolo && protocolo.trim().length > 0 && protocolo.trim() !== 'OUTROS') {
		labelProtcolo = (
			<span style={{
				backgroundColor: '#EF3D5F',
				color: 'white',
				fontWeight: 'bold',
				padding: '4px 4px',
				marginLeft: '8px',
				verticalAlign: 'middle',
				borderRadius: '4px',
				fontSize: '1.3rem',
				whiteSpace: 'nowrap',
				cursor: 'default'
			}}>
				{
					(() => {
						const trimmed = protocolo.trim();
						switch (trimmed) {
							case 'OUTROS':
								return '';
							case 'DOR_TORACICA':
								return 'DOR TORÁCICA';
							case 'SEPSE':
								return 'SEPSE';
							default:
								return trimmed.toUpperCase();
						}
					})()
				}
			</span>
		);
	}

	return labelProtcolo;
};

export const cardCategoriaPaciente = (categoria) => {
	let labelCategoria = '';
	if (categoria && categoria.trim().length > 0 && categoria.trim() !== '') {
		let bgColor = null;
		if (categoria == 'Oncológico') {
			bgColor = '#FEC30A';
		} else if (categoria == 'VIP') {
			bgColor = '#9800B7';
		}
		labelCategoria = (
			<span style={{
				backgroundColor: bgColor,
				color: 'white',
				fontWeight: 'bold',
				padding: '4px 4px',
				marginLeft: '8px',
				verticalAlign: 'middle',
				borderRadius: '4px',
				fontSize: '1.3rem',
				whiteSpace: 'nowrap',
				cursor: 'default'
			}}>
				{
					(() => {
						const trimmed = categoria.trim();
						return trimmed;
					})()
				}
			</span>
		);
	}

	return labelCategoria;
};

export const cardProbabilidadeInternacao = (porcentagem, fontSize = '1.3rem') => {
	let labelProbabilidade = '';
	if (porcentagem != null) {
		labelProbabilidade = (
			<span 
				data-toggle="tooltip" 
				title="Probabilidade de Internação"
				style={{
					backgroundColor: '#d4d4d4',
					color: '#4d4d4d',
					padding: '4px 4px',
					marginLeft: '8px',
					verticalAlign: 'middle',
					borderRadius: '4px',
					fontSize: fontSize,
					whiteSpace: 'nowrap',
					cursor: 'default'
				}}>{porcentagem + '%'}
			</span>
		);
	}

	return labelProbabilidade;
};

export const camelCase = (str) => {
	let camelStr = str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
	camelStr = camelStr
		.split('/')
		.map(part => part.trim().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '))
		.join(' / ');
	// manter as preposições em minúsculo
	camelStr = camelStr.replace(/ De /g, ' de ').replace(/ Da /g, ' da ').replace(/ Do /g, ' do ').replace(/ E /g, ' e ');

	// abrevia os nomes do meio exceto as preposições
	camelStr = camelStr.split(' / ').map(part => {
		return part.split(' ').map((word, idx, arr) => {
			if (idx !== 0 && idx !== arr.length - 1 && !['de', 'da', 'do', 'e'].includes(word.toLowerCase())) {
				return word.charAt(0) + '.';
			}
			return word;
		}).join(' ');
	}).join(' / ');

	return camelStr;
};